export default {"src":"/_next/static/media/microsoft.9e3b6d05.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};